import { render } from "./StatementsModal.vue?vue&type=template&id=9a0c3fb6&scoped=true"
import script from "./StatementsModal.vue?vue&type=script&lang=js"
export * from "./StatementsModal.vue?vue&type=script&lang=js"

import "./StatementsModal.vue?vue&type=style&index=0&id=9a0c3fb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a0c3fb6"]])

export default __exports__